export const DOM_ELEM_ID = {
  ROOT: 'root',
  MAIN_CONTENT: 'root-content',
  TOASTS: 'toasts',
  PORTAL: 'portal'
};
